var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ECE4D31C-0146-461F-887E-3D2503861C46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,36 C13.5954,36 14.4,36.8064 14.4,37.8 L14.4,48.6 C14.4,49.5936 13.5954,50.4 12.6,50.4 L1.8,50.4 C0.8046,50.4 0,49.5936 0,48.6 L0,37.8 C0,36.8064 0.8046,36 1.8,36 L12.6,36 Z M12.6,18 C13.5954,18 14.4,18.8064 14.4,19.8 L14.4,30.6 C14.4,31.5936 13.5954,32.4 12.6,32.4 L1.8,32.4 C0.8046,32.4 0,31.5936 0,30.6 L0,19.8 C0,18.8064 0.8046,18 1.8,18 L12.6,18 Z M30.6,18 C31.5954,18 32.4,18.8064 32.4,19.8 L32.4,30.6 C32.4,31.5936 31.5954,32.4 30.6,32.4 L19.8,32.4 C18.8046,32.4 18,31.5936 18,30.6 L18,19.8 C18,18.8064 18.8046,18 19.8,18 L30.6,18 Z M12.6,0 C13.5954,0 14.4,0.8064 14.4,1.8 L14.4,12.6 C14.4,13.5936 13.5954,14.4 12.6,14.4 L1.8,14.4 C0.8046,14.4 0,13.5936 0,12.6 L0,1.8 C0,0.8064 0.8046,0 1.8,0 L12.6,0 Z M30.6,0 C31.5954,0 32.4,0.8064 32.4,1.8 L32.4,12.6 C32.4,13.5936 31.5954,14.4 30.6,14.4 L19.8,14.4 C18.8046,14.4 18,13.5936 18,12.6 L18,1.8 C18,0.8064 18.8046,0 19.8,0 L30.6,0 Z M48.6,0 C49.5954,0 50.4,0.8064 50.4,1.8 L50.4,12.6 C50.4,13.5936 49.5954,14.4 48.6,14.4 L37.8,14.4 C36.8046,14.4 36,13.5936 36,12.6 L36,1.8 C36,0.8064 36.8046,0 37.8,0 L48.6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,18 C13.5954,18 14.4,18.8064 14.4,19.8 L14.4,30.6 C14.4,31.5936 13.5954,32.4 12.6,32.4 L1.8,32.4 C0.8046,32.4 0,31.5936 0,30.6 L0,19.8 C0,18.8064 0.8046,18 1.8,18 L12.6,18 Z M30.6,18 C31.5954,18 32.4,18.8064 32.4,19.8 L32.4,30.6 C32.4,31.5936 31.5954,32.4 30.6,32.4 L19.8,32.4 C18.8046,32.4 18,31.5936 18,30.6 L18,19.8 C18,18.8064 18.8046,18 19.8,18 L30.6,18 Z M30.6,0 C31.5954,0 32.4,0.8064 32.4,1.8 L32.4,12.6 C32.4,13.5936 31.5954,14.4 30.6,14.4 L19.8,14.4 C18.8046,14.4 18,13.5936 18,12.6 L18,1.8 C18,0.8064 18.8046,0 19.8,0 L30.6,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.1-WebPageBuilder-EmptyWidgets",
    transform: "translate(-1219.000000, -710.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bar",
    transform: "translate(1077.000000, 540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Heatmap/40dp",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(10.800000, 10.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.800000, -10.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(28.800000, 28.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28.800000, -28.800000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap);
export default __webpack_public_path__ + "static/media/heatMap.e9ea2607d66ad4acc186ed37381c208d.svg";
export { ForwardRef as ReactComponent };